import React from 'react';
import { Card } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
// import Styles from './DevicePreviewCardLoader.module.scss';
import Styles from '../AccessoryPreviewCardLoader/AccessoryPreviewCardLoader.module.scss'
// import 'react-loading-skeleton/dist/skeleton.css';

const AccessoryPreviewCardSkeletonBody = () => {
  return (
    <div>
      <Card className={Styles.cards}>
        <Card.Body>
          {/* Title */}
          <div className='row justify-content-between'>
            <div className='col-8'>
              <Skeleton height={24} width={'100%'} />
              <Skeleton height={24} width={'60%'} />
            </div>
            <div className='col-2'>
                <Skeleton height={24} width={30} />
            </div>
          </div>
          <hr />
          {/* Image */}
          <div className={`${Styles.SkeletonImage}`}>
            <Skeleton height={312} width={'75%'} />
          </div>
          {/* Price */}
          <div className={Styles.priceSection}>
            <div className={Styles.pricePadding}>
              <div className='row justify-content-between'>
                <div className='col-8'>
                  <Skeleton height={40} width={'65%'} />
                  <Skeleton height={20} width={'85%'} />
                </div>
                {/* button */}
                <div className={`${Styles.button} col-2`}>
                  <Skeleton circle={true} height={48} width={48} />
                </div>
              </div>
              <hr />
              <Skeleton height={24} width={'75%'} />
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default AccessoryPreviewCardSkeletonBody;
